import { render, staticRenderFns } from "./GeneralTermDetail.vue?vue&type=template&id=ebdcb906&"
import script from "./GeneralTermDetail.vue?vue&type=script&lang=ts&"
export * from "./GeneralTermDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports